import React, {useMemo} from 'react';
import {IMaskInput} from 'react-imask';
import {InputBaseComponentProps} from '@mui/material';
import { useMnoContext } from '@/context/MnoContext';

// The props that PhoneNumberMask actually needs
interface CustomMaskProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

// Create a type that combines InputBaseComponentProps with our custom props
type PhoneNumberMaskProps = InputBaseComponentProps & Partial<CustomMaskProps>;

export const PhoneNumberMask = React.forwardRef<HTMLInputElement, PhoneNumberMaskProps>(
    function PhoneNumberMask(props, ref) {
        const {onChange, name = 'phoneNumber', ...other} = props;
        const { config } = useMnoContext();
        const PHONE_NUMBER_MASK = config.phoneNumberMask;
        
        const getPlaceHolder = useMemo((): string => {
            let count = 1;
          return PHONE_NUMBER_MASK.split('').map((letter) => {
               return letter === '0' ? String(count++ % 10) : letter
            }).join('');
        }, [PHONE_NUMBER_MASK]);
        return (
            <IMaskInput
                {...other}
                mask={PHONE_NUMBER_MASK}
                definitions={{
                    '#': /[1-9]/,
                }}
                inputRef={ref}
                onAccept={(value: string) => {
                    if (onChange) {
                        onChange({target: {name, value}});
                    }
                }}
                placeholder={getPlaceHolder}
            />
        );
    },
); 